// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination } from 'swiper';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';

const isIpadPro = () => {
    let ratio = window.devicePixelRatio || 1;
    let screen = {
        width : window.screen.width * ratio,
        height : window.screen.height * ratio
    };
    return (screen.width === 1488 && screen.height === 2266) ||(screen.width === 2048 && screen.height === 2732) || (screen.width === 2732 && screen.height === 2048) || (screen.width === 1536 && screen.height === 2048) || (screen.width === 2048 && screen.height === 1536) || (screen.width === 1668 && screen.height === 2388) || (screen.width === 2388 && screen.height === 1668) || (screen.width === 1620 && screen.height === 2160);
}
const servicesOverviewSlider = () => {
    if(document.querySelector('.suizidpraevention-slider')){

        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        const allSliders = document.querySelectorAll('.suizidpraevention-slider');
        allSliders.forEach(slider =>{

            const prevSlide = slider.querySelector('.swiper-button-prev');
            const nextSlide = slider.querySelector('.swiper-button-next');
            const swiper = new Swiper(slider, {
                modules: [Navigation],
                slidesPerView: 1,
                navigation: {
                    nextEl: nextSlide,
                    prevEl: prevSlide,
                },
                breakpoints: {
                    900: {
                        slidesPerView: 2,
                        spaceBetween: 80
                    },

                    1367: {
                        slidesPerView: 4,
                        spaceBetween: 100
                    }
                }
            })
            swiper.init();
        })

    }
    if(document.querySelector('.suizidpraevention-bullet-nav-slider')){


        const allSliders = document.querySelectorAll('.suizidpraevention-bullet-nav-slider');
        allSliders.forEach(sliderParent =>{
            const slider = sliderParent.querySelector('.swiper');
            const prevSlide = sliderParent.querySelector('.swiper-button-prev');
            const nextSlide = sliderParent.querySelector('.swiper-button-next');
            const pag = sliderParent.querySelector('.swiper-pagination');
            const swiper = new Swiper(slider, {
                modules: [Navigation, Pagination],
                slidesPerView: 1,
                navigation: {
                    nextEl: nextSlide,
                    prevEl: prevSlide,
                },
                pagination: {
                    el: pag,
                    type: 'bullets',
                    clickable: true,
                },
                on: { init: function(e){ const bulletNumber = document.querySelectorAll('.swiper-pagination-bullet'); /* Hide pagination */ if(bulletNumber.length == 1){ document.querySelector('.swiper-pagination').style.display = 'none'; } } }

            })
            swiper.init();
        })

    }
}
export default servicesOverviewSlider;